// extracted by mini-css-extract-plugin
module.exports = {"inactiveStatusWrapper":"InactiveStatus_inactiveStatusWrapper__1on_9"};